import { Badge } from '@scale/scaleui-radix';
import { OTSDeliveredBatchStatus } from '@scale/shared/ots';

type BadgeProps = React.ComponentProps<typeof Badge>;
export const OTS_DELIVERY_STATUS_TO_COLOR: Record<OTSDeliveredBatchStatus, BadgeProps['color']> = {
  [OTSDeliveredBatchStatus.Draft]: 'neutral',
  [OTSDeliveredBatchStatus.Delivered]: 'success',
  [OTSDeliveredBatchStatus.Cancelled]: 'neutral',
  [OTSDeliveredBatchStatus.Processing]: 'warning',
  [OTSDeliveredBatchStatus.Error]: 'error',
};
